import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Product from 'components/Product';
import productsStore from 'stores/new/Products';
import ProductAction from "actions/Product/";
import TagManagerService from 'services/TagManager';
import PubSub from 'services/PubSub';
import { actionsType } from 'config/constants';
import StorageService from 'services/StorageService';
import FavoritesActions from 'actions/Favorites'
import RenderService from 'services/Render'
import ProductFactory from 'factories/Products'
import style from './style.scss'; //NOSONAR

let actions = [];
let slug = '';
let previewPath = '';

const getInitialState = () => {
    const data = RenderService.getRenderData();

    if(!(data && data.pdp && data.pdp.product)){
        return {};
    }

    const product = data.pdp.product;

    return {
        product: product[0] ? ProductFactory.create(product[0]) : null
    };
}

const ProductContainer = (props) => {
    slug =  props.match.params.slug;
    const initialState = getInitialState();
    const [product, setProduct] = useState(initialState.product || null);
    const [isLoaded, setIsLoaded] = useState(!!initialState.product);
    const {store} = props;

    useEffect(() => {
        let prods = store.products.get('product');
        if(prods && prods.toList){
            prods = prods.toList().toArray();
            setProduct(prods[0]);
        }
        previewPath = props && props.location && props.location.pathname ? props.location.pathname : '';
    }, [store]);


    useEffect(() => {

        if (previewPath && props.location.pathname !== previewPath) {
            slug = props.match.params.slug;
            previewPath = props.location.pathname;
            _getProduct();
        }

        FavoritesActions.getFavorites(false);

    }, [props && props.location && props.location.pathname ? props.location.pathname : '']);


    useEffect(() => {
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => {
            setIsLoaded(false);
            setProduct(null);
            _getProduct();
        }));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    useEffect(() => {
        _getProduct();
    }, []);


    const  _getProduct = () =>{
        setProduct(null);
        setIsLoaded(false);
        
        const listPdp = StorageService.getItem('list_pdp');
        if(listPdp ) {
            StorageService.removeItem('list_pdp');
        }

        ProductAction.getProduct(slug).then(prod => {
            if(prod) TagManagerService.productDetail(prod, listPdp && (listPdp != 'null') ? listPdp : null);
            setIsLoaded(true);
        }).catch(()=> {
            setIsLoaded(true);
        });
    }

    return (
        <div className={'product-container page'}>
            <Product {...props} product={product} isLoaded={isLoaded}/>
        </div>
    )


};

ProductContainer.propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
    store : PropTypes.object
};

export default productsStore.wrapConsumer(ProductContainer);



